import React from 'react';
import {SvgIcon} from 'components';

export const SearchIcon: SvgIcon = ({
  width = 18,
  height = 18,
  strokeWidth = 1.2,
  fillColor = 'black',
  classes = '',
}) => (
  <svg
    width={width}
    height={height}
    fill={fillColor}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 18 18"
    className={`text-black ${classes}`}
  >
    <path
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      fill={fillColor}
      d="M6.5 13C4.68333 13 3.146 12.3707 1.888 11.112C0.63 9.85333 0.000667196 8.316 5.29101e-07 6.5C-0.000666138 4.684 0.628667 3.14667 1.888 1.888C3.14733 0.629333 4.68467 0 6.5 0C8.31533 0 9.853 0.629333 11.113 1.888C12.373 3.14667 13.002 4.684 13 6.5C13 7.23333 12.8833 7.925 12.65 8.575C12.4167 9.225 12.1 9.8 11.7 10.3L17.3 15.9C17.4833 16.0833 17.575 16.3167 17.575 16.6C17.575 16.8833 17.4833 17.1167 17.3 17.3C17.1167 17.4833 16.8833 17.575 16.6 17.575C16.3167 17.575 16.0833 17.4833 15.9 17.3L10.3 11.7C9.8 12.1 9.225 12.4167 8.575 12.65C7.925 12.8833 7.23333 13 6.5 13ZM6.5 11C7.75 11 8.81267 10.5627 9.688 9.688C10.5633 8.81333 11.0007 7.75067 11 6.5C10.9993 5.24933 10.562 4.187 9.688 3.313C8.814 2.439 7.75133 2.00133 6.5 2C5.24867 1.99867 4.18633 2.43633 3.313 3.313C2.43967 4.18967 2.002 5.252 2 6.5C1.998 7.748 2.43567 8.81067 3.313 9.688C4.19033 10.5653 5.25267 11.0027 6.5 11Z"
    />
  </svg>
);

export const ArrowDownIcon: SvgIcon = ({
  width = 17,
  height = 17,
  strokeWidth = 1.5,
  fillColor = 'black',
  strokeColor = '',
  classes = '',
}) => (
  <svg
    width={width}
    height={height}
    fill={fillColor}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 17 17"
    className={`stroke-current ${classes} ${strokeColor}`}
  >
    <path
      d="M8.5 16L8.5 1L8.5 16ZM1.5 9.57143L8.5 16L1.5 9.57143ZM15.5 9.57143L8.5 16L15.5 9.57143Z"
      fill={fillColor}
    />
    <path
      d="M8.5 16L8.5 0.999999M8.5 16L1.5 9.57143M8.5 16L15.5 9.57143"
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const CaretRightIcon: SvgIcon = ({
  width = 7,
  height = 11,
  strokeWidth = 1.5,
  fillColor = 'none',
  strokeColor = 'text-white',
  classes = '',
}) => (
  <svg
    width={width}
    height={height}
    fill={fillColor}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 7 11"
    className={`stroke-current ${classes} ${strokeColor}`}
  >
    <path d="M0.75 1L5.25 5.5L0.75 10" strokeWidth={strokeWidth} />
  </svg>
);

export const FilterBarsIcon: SvgIcon = ({
  width = 12,
  height = 9,
  strokeWidth = 1.5,
  fillColor = 'none',
  strokeColor = 'text-blue-600',
  classes = '',
}) => (
  <svg
    width={width}
    height={height}
    fill={fillColor}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 12 9"
    className={`stroke-current ${classes} ${strokeColor}`}
  >
    <path d="M0 1.5H12" strokeWidth={strokeWidth} />
    <path d="M2 4.5H10" strokeWidth={strokeWidth} />
    <path d="M4 7.5H8" strokeWidth={strokeWidth} />
  </svg>
);

export const BarMenuIcon: SvgIcon = ({
  width = 18,
  height = 13,
  fillColor = 'none',
  classes = '',
}) => (
  <svg
    width={width}
    height={height}
    fill={fillColor}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 18 13"
    className={`text-black ${classes}`}
  >
    <path
      d="M1 12.5C0.71667 12.5 0.479337 12.404 0.288004 12.212C0.0966702 12.02 0.000670115 11.7827 3.44827e-06 11.5C-0.000663218 11.2173 0.0953369 10.98 0.288004 10.788C0.48067 10.596 0.718003 10.5 1 10.5H17C17.2833 10.5 17.521 10.596 17.713 10.788C17.905 10.98 18.0007 11.2173 18 11.5C17.9993 11.7827 17.9033 12.0203 17.712 12.213C17.5207 12.4057 17.2833 12.5013 17 12.5H1ZM1 7.5C0.71667 7.5 0.479337 7.404 0.288004 7.212C0.0966702 7.02 0.000670115 6.78267 3.44827e-06 6.5C-0.000663218 6.21733 0.0953369 5.98 0.288004 5.788C0.48067 5.596 0.718003 5.5 1 5.5H17C17.2833 5.5 17.521 5.596 17.713 5.788C17.905 5.98 18.0007 6.21733 18 6.5C17.9993 6.78267 17.9033 7.02033 17.712 7.213C17.5207 7.40567 17.2833 7.50133 17 7.5H1ZM1 2.5C0.71667 2.5 0.479337 2.404 0.288004 2.212C0.0966702 2.02 0.000670115 1.78267 3.44827e-06 1.5C-0.000663218 1.21733 0.0953369 0.98 0.288004 0.788C0.48067 0.596 0.718003 0.5 1 0.5H17C17.2833 0.5 17.521 0.596 17.713 0.788C17.905 0.98 18.0007 1.21733 18 1.5C17.9993 1.78267 17.9033 2.02033 17.712 2.213C17.5207 2.40567 17.2833 2.50133 17 2.5H1Z"
      fill="black"
    />
  </svg>
);
